import * as React from "react"
import LoginCard from "./LoginCard"
import ResetPassword from "./ResetPassword"
import RegisterCard from "./RegisterCard"
import TwoFactorAuthenicationCard from "./2faCard"
import BackupTokenCard from "./BackupTokenCard"
import { useLocation } from "react-router-dom"

interface Props {
  onCloseModal: () => void
  initialPage?: "login" | "register" | "reset" | "2fa" | "backup"
}

const LoginModalContainer: React.FC<Props> = ({ onCloseModal, initialPage }) => {
  const [currentPage, setCurrentPage] = React.useState<"login" | "register" | "reset" | "2fa" | "backup">(
    initialPage ?? "login",
  )
  const redirectUrl = new URLSearchParams(window.location.search).get("next") || undefined

  const location = useLocation()

  React.useEffect(() => {
    if (location?.pathname?.includes("signup")) {
      setCurrentPage("register")
    }
  }, [])

  const [userHasBackupTokens, setUserHasBackupTokens] = React.useState(false)

  const onClickCancelForgotPassowrd = () => setCurrentPage("login")
  const onClickRegister = () => setCurrentPage("register")
  const onGoTo2fa = () => setCurrentPage("2fa")
  const onClickBackup = () => setCurrentPage("backup")

  return (
    <div>
      {currentPage === "login" ? (
        <LoginCard
          onClickForgotPassword={() => setCurrentPage("reset")}
          onClickRegister={onClickRegister}
          onCloseModal={onCloseModal}
          onGoTo2fa={onGoTo2fa}
          setUserHasBackupTokens={setUserHasBackupTokens}
          redirectUrl={redirectUrl}
        />
      ) : currentPage === "reset" ? (
        <ResetPassword onClickCancelForgotPassowrd={onClickCancelForgotPassowrd} />
      ) : currentPage === "2fa" ? (
        <TwoFactorAuthenicationCard
          onClickBackupToken={onClickBackup}
          onCloseModal={onCloseModal}
          onClickGoBack={onClickCancelForgotPassowrd}
          userHasBackupTokens={userHasBackupTokens}
          redirectUrl={redirectUrl}
        />
      ) : currentPage === "backup" ? (
        <BackupTokenCard onClickGoBack={onGoTo2fa} onCloseModal={onCloseModal} redirectUrl={redirectUrl} />
      ) : (
        <RegisterCard onClickCancelRegister={onClickCancelForgotPassowrd} onClose={onCloseModal} />
      )}
    </div>
  )
}

export default LoginModalContainer
